<md-dialog>
  <div md-dialog-header>
    <h2>Change Instructor</h2>
  </div>

  <!-- Real class, not .dialog-content: md-dialog already renders a .dialog-content around this and its
  styles are unencapsulated, so reusing that name would create a second scroll container. The width
  lives here rather than on the dialog so the long instructor labels cannot stretch it open. -->
  <div class="substitute-instructor-dialog">
    <div class="current-info">
      <div class="field"><strong>Current Instructor:</strong> {{ currentInstructorName() }}</div>
      @if (isCovered()) {
        <!-- Only shown when the two differ, which is exactly when the admin needs to know they do:
        this lesson has been covered, so its instructor is not the enrollment's. -->
        <div class="field"><strong>Enrollment Instructor:</strong> {{ enrollment().instructor?.instructorFullName }}</div>
      }
      @if (languageName()) {
        <div class="field"><strong>Language:</strong> {{ languageName() }}</div>
      }
    </div>

    @if (!error()) {
      @if (loadingInstructors()) {
        <lb-loader></lb-loader>
      } @else if (filteredInstructorOptions().length === 0) {
        <div class="empty">No instructors available for this language.</div>
      } @else {
        <!-- lb-form-field renders ng-content only, so the label must be a child element. It has no
        `label` input — passing one as an attribute renders nothing at all. -->
        <lb-form-field>
          <label>Select New Instructor</label>
          <md-drop-down
            [options]="filteredInstructorOptions()"
            [placeholder]="'Choose instructor'"
            [value]="selectedInstructorUserId()"
            [disabled]="isFormDisabled()"
            (change)="onInstructorChange($event)"
          ></md-drop-down>
        </lb-form-field>

        <lb-form-field>
          <label>Reason (optional)</label>
          <input
            md-form-input
            type="text"
            [value]="reason()"
            [disabled]="isFormDisabled()"
            placeholder="e.g. Instructor illness"
            (input)="onReasonChange($any($event.target).value)"
          />
        </lb-form-field>
      }

      @if (isNoOpSelection()) {
        <div class="hint">That instructor already teaches this lesson.</div>
      } @else if (isReturnToPrimary()) {
        <div class="hint">This returns the lesson to the enrollment's own instructor and ends the substitution.</div>
      }

      @if (updateError()) {
        <div class="error">{{ updateError() }}</div>
      }
    } @else {
      <div class="error">{{ error() }}</div>
    }
  </div>

  <div md-dialog-footer>
    <button md-button (click)="close()" appearance="outline" [disabled]="loadingUpdate()">Cancel</button>
    <button md-button color="primary" [disabled]="!canConfirm()" (click)="confirm()">
      @if (loadingUpdate()) {
        <span>Updating...</span>
      }
      @if (!loadingUpdate()) {
        <span>{{ confirmLabel() }}</span>
      }
    </button>
  </div>
</md-dialog>
